import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";

declare const __BUILD_SHA__: string;
// Fingerprint the running build (vite define) — readable from the DOM and
// greppable in the shipped bundle as BUILD_SHA:<sha>, so deploy-verification
// can prove which commit is actually live.
document.documentElement.dataset.build = `BUILD_SHA:${__BUILD_SHA__}`;

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
